import { useSubscription } from "./useSubscription";

export function usePlan() {
  const { subscription, isLoading } = useSubscription();
  return {
    plan: subscription.plan,
    isPro: subscription.plan === "pro",
    isLoading,
  };
}
